import { ApolloCache, FetchResult } from "@apollo/client";
import { MarkClubAsFavouriteMutation } from "api";

/**
 * Updates the Apollo cache after adding a club.
 *
 * This function modifies the `getFavouriteClubsOfUser` field in the cache by adding
 * favorite club
 *
 * @returns A function that takes the Apollo cache object and performs the cache modification.
 */

export const updateCacheForFavouriteClub =
  () =>
  (
    cache: ApolloCache<any>,
    { data }: Omit<FetchResult<MarkClubAsFavouriteMutation>, "context">
  ) => {
    cache.modify({
      fields: {
        getFavouriteClubsOfUser: (previous) => [
          data?.markClubAsFavourite,
          ...previous,
        ],
      },
    });
  };
